function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#publish-shift-modal_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 40,
  width: 174,
  height: 67,
  rx: 2,
  fill: "#fff"
}));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 40,
  y: 76,
  width: 48,
  height: 21,
  rx: 2,
  fill: "#0085FF"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M43 79h42v6H43zM43 88h28v6H43z"
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 93,
  y: 50,
  width: 48,
  height: 21,
  rx: 2,
  fill: "#B39DDB"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M96 53h42v6H96zM96 62h28v6H96z"
});
var _ref7 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 146,
  y: 50,
  width: 48,
  height: 21,
  rx: 2,
  fill: "#B39DDB"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M149 53h42v6h-42zM149 62h28v6h-28z"
});
var _ref9 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 93,
  y: 76,
  width: 48,
  height: 21,
  rx: 2,
  fill: "#0085FF"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M96 79h42v6H96zM96 88h28v6H96z"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  fill: "#0085FF",
  d: "M40 50h3v9h-3zM40 61h3v3h-3z"
});
var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "publish-shift-modal_svg__filter0_d",
  x: 22,
  y: 34,
  width: 190,
  height: 83,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));
function SvgPublishShiftModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 140,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10);
}
export default SvgPublishShiftModal;